define( function() {
	"use strict";

	return Date.now();
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/ajax/var/nonce.js
// module id = 396
// module chunks = 1